import { urlFor } from './helpers';
import type { ImageViewerImage } from 'components/collection/image-viewer';
import type {
	ISanityVisualDatabaseImage,
	ICollectionImage,
} from '@metmuseum/types';
import { isExpandedImage } from '@metmuseum/types';

export function collectionImageToImageViewerImage(
	collectionImage: ICollectionImage,
): ImageViewerImage {
	return {
		altText: collectionImage.altText,
		webImageUrl: collectionImage.webImageUrl,
		isOpenAccess: collectionImage.isOasc,
		originalImageUrl: collectionImage.originalImageUrl,
		publicCaption: collectionImage.publicCaption,
	};
}

export function visualDatabaseImageToImageViewerImage(
	visualDatabaseImage: ISanityVisualDatabaseImage,
): ImageViewerImage {
	const isOpenAccess = visualDatabaseImage.rightsType === 'openAccess';
	const imageWidth = isExpandedImage(visualDatabaseImage.image)
		? (visualDatabaseImage.image.asset.metadata?.dimensions?.width ?? 0)
		: 0;
	const imageUrl = urlFor(visualDatabaseImage.image, 75, imageWidth) ?? '';

	// webImageUrl and originalImageUrl are intentionally the same because we're doing dimension restriction on the Sanity side.
	// If we want to make these different in the future, this is a good place to do it.
	return {
		altText: visualDatabaseImage.image.alt ?? '',
		webImageUrl: imageUrl,
		isOpenAccess,
		originalImageUrl: imageUrl,
		publicCaption: visualDatabaseImage.image.credit ?? '',
	};
}
